// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compound-input {
   display: flex;
   align-items: center;
   border: var(--border);
   border-radius: var(--border-radius);
   background: var(--frame-bg);
   height: var(--input-height);
   width: 100%;
   margin-right: 5px;
}

@media (min-width: 769px) and (orientation: portrait),
(min-height: 769px) and (orientation: landscape) {
   .compound-input {
      height: 32px;
   }
}

.compound-input>* {
   margin: 0px 5px;
}

.compound-input:focus-within {
   outline: var(--outline-focus-visible);
}

.compound-input:hover {
   background-color: var(--frame-bg-hovered);
}

.compound-input>.themed-svg-container {
   width: 1em;
   height: 1em;
}

.compound-input input {
   border: transparent;
   width: calc(100% - 70px);
   margin: 0;
   background-color: unset;
   height: unset;
   cursor: auto !important;
}

.compound-input input:focus-visible {
   outline: none;
}

.compound-input input:hover {
   background-color: unset;
}

.compound-input button {
   border: none;
   background: none;
   padding: 0;
   margin: 0;
   border-radius: none;
   max-width: 30px;
   display: flex;
   align-items: center;
   justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLInputs/ECLCompoundInput/ECLCompoundInput.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,mBAAmB;GACnB,qBAAqB;GACrB,mCAAmC;GACnC,2BAA2B;GAC3B,2BAA2B;GAC3B,WAAW;GACX,iBAAiB;AACpB;;AAEA;;GAEG;MACG,YAAY;GACf;AACH;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,qCAAqC;AACxC;;AAEA;GACG,yCAAyC;AAC5C;;AAEA;GACG,UAAU;GACV,WAAW;AACd;;AAEA;GACG,mBAAmB;GACnB,wBAAwB;GACxB,SAAS;GACT,uBAAuB;GACvB,aAAa;GACb,uBAAuB;AAC1B;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,YAAY;GACZ,gBAAgB;GAChB,UAAU;GACV,SAAS;GACT,mBAAmB;GACnB,eAAe;GACf,aAAa;GACb,mBAAmB;GACnB,uBAAuB;AAC1B","sourcesContent":[".compound-input {\r\n   display: flex;\r\n   align-items: center;\r\n   border: var(--border);\r\n   border-radius: var(--border-radius);\r\n   background: var(--frame-bg);\r\n   height: var(--input-height);\r\n   width: 100%;\r\n   margin-right: 5px;\r\n}\r\n\r\n@media (min-width: 769px) and (orientation: portrait),\r\n(min-height: 769px) and (orientation: landscape) {\r\n   .compound-input {\r\n      height: 32px;\r\n   }\r\n}\r\n\r\n.compound-input>* {\r\n   margin: 0px 5px;\r\n}\r\n\r\n.compound-input:focus-within {\r\n   outline: var(--outline-focus-visible);\r\n}\r\n\r\n.compound-input:hover {\r\n   background-color: var(--frame-bg-hovered);\r\n}\r\n\r\n.compound-input>.themed-svg-container {\r\n   width: 1em;\r\n   height: 1em;\r\n}\r\n\r\n.compound-input input {\r\n   border: transparent;\r\n   width: calc(100% - 70px);\r\n   margin: 0;\r\n   background-color: unset;\r\n   height: unset;\r\n   cursor: auto !important;\r\n}\r\n\r\n.compound-input input:focus-visible {\r\n   outline: none;\r\n}\r\n\r\n.compound-input input:hover {\r\n   background-color: unset;\r\n}\r\n\r\n.compound-input button {\r\n   border: none;\r\n   background: none;\r\n   padding: 0;\r\n   margin: 0;\r\n   border-radius: none;\r\n   max-width: 30px;\r\n   display: flex;\r\n   align-items: center;\r\n   justify-content: center;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
